import Link from 'next/link'
import React from 'react'
import { Program } from '~shared/api/categories/types'
import { getPopularPrograms } from '~shared/api/programs-popular/getPopularPrograms'
import { TPopProgram } from '~shared/api/programs-popular/types'
import { Hit } from '~shared/icons/hit'

type Props = {
  popularProgram: TPopProgram
}

export const PopularProgramCard: React.FC<Props> = ({ popularProgram }) => {
  return (
    <Link
      prefetch={false}
      href={`/${popularProgram.slug}--${
        popularProgram.category?.slugSingular ?? popularProgram.category?.slug
      }`}>
      <div className='relative'>
        <img
          loading='lazy'
          src={popularProgram?.image.url}
          alt={popularProgram?.name ?? 'program image'}
          className='object-cover rounded-[24px] w-full  max-h-[250px] md:max-h-none md:aspect-square'
        />
        <div className='p-[16px] absolute top-0 left-0 w-full h-full xl:p-[24px] flex flex-col justify-between z-20'>
          <div className='flex gap-[4px] justify-between items-start  text-[14px] md:text-[16px]'>
            <div className='flex flex-wrap gap-y-[8px]'>
              <div className='bg-white rounded-[24px]  h-fit overflow-hidden'>
                <span
                  className='px-[10px]  py-[6px] flex items-center max-w-[200px]'
                  style={
                    popularProgram?.faculty?.color
                      ? {
                          backgroundColor: `${popularProgram?.faculty?.color}30`,
                          color: popularProgram?.faculty?.color
                        }
                      : {}
                  }>
                  {popularProgram?.faculty?.name}
                </span>
              </div>
              <span className='bg-white px-[10px]  py-[6px] flex items-center rounded-[24px]'>
                {popularProgram?.category?.name}
              </span>
            </div>
            <span className='flex items-center rounded-[24px] gap-[4px] bg-[#FFF741] px-[10px] py-[6px]'>
              <Hit size={13} className='hidden md:inline-block' />
              <Hit size={8} className='md:hidden' />
              хит
            </span>
          </div>
          <div className='text-white'>
            <p className='text-[16px] md:text-[24px] font-medium'>
              {popularProgram?.name}
            </p>
            <p className='text-[14px] mt-[8px] xl:mt-[16px]'>
              {Number(popularProgram?.cost?.studyDurationYears) > 0 && (
                <span>{popularProgram?.cost?.studyDurationYears} год </span>
              )}
              {Number(popularProgram?.cost?.studyDurationYears) > 0 &&
                Number(popularProgram?.cost?.studyDurationMonths) > 0 && (
                  <span>/ </span>
                )}
              {Number(popularProgram?.cost?.studyDurationMonths) > 0 && (
                <span>{popularProgram?.cost?.studyDurationMonths} мес </span>
              )}
              {Number(popularProgram?.cost?.studyHours) > 0 && (
                <span>/ {popularProgram?.cost?.studyHours} часов </span>
              )}
            </p>
          </div>
        </div>
        <div className='absolute top-0 left-0 w-full h-full bg-[#00000040] z-10 rounded-[24px]' />
      </div>
    </Link>
  )
}
